<script setup lang="ts">
import { reactive, defineProps, defineEmits } from 'vue'
import OnboardingPayslipUploadInput from './OnboardingPayslipUploadInput.vue'

interface FormParams {
  user: {
    nom: string
    prenom: string
    email: string
    telephone: string
  }
  photo: {
    preview?: string | ArrayBuffer | null
  } | null
}

const props = defineProps<{
  formParams: FormParams
  loading: boolean
  hideHeader?: boolean
  hideTitle?: boolean
  hidePreviousLink?: boolean
}>()

const emit = defineEmits<{
  (e: 'saved', payload: typeof formData): void
}>()

const formData = reactive({
  bulletin1: null as { file: File; name: string } | null,
  bulletin2: null as { file: File; name: string } | null,
  bulletin3: null as { file: File; name: string } | null
})

const errors = reactive<Record<string, string>>({
  bulletin1: '',
  bulletin2: '',
  bulletin3: ''
})

function validate() {
  let isValid = true
  Object.keys(errors).forEach(key => (errors[key] = ''))

  if (!formData.bulletin1) {
    errors.bulletin1 = 'Le bulletin 1 est requis'
    isValid = false
  }
  if (!formData.bulletin2) {
    errors.bulletin2 = 'Le bulletin 2 est requis'
    isValid = false
  }
  if (!formData.bulletin3) {
    errors.bulletin3 = 'Le bulletin 3 est requis'
    isValid = false
  }

  return isValid
}

function onFileUploaded(field: 'bulletin1' | 'bulletin2' | 'bulletin3', uploadedFile: { file: File; file_name: string }) {
  formData[field] = {
    file: uploadedFile.file,
    name: uploadedFile.file_name
  }
  // Émettre automatiquement les données mises à jour quand un fichier est uploadé
  // Cela permet de garder les données à jour dans le parent sans avoir besoin d'un bouton "Valider"
  emit('saved', { ...formData })
}
</script>

<template>
  <form class="form">
    <onboarding-payslip-upload-input id="bulletin1-upload" @uploaded="onFileUploaded('bulletin1', $event)" caption=".1" label="Bulletin de salaire (1)" />
    <span v-if="errors.bulletin1" class="text-red">{{ errors.bulletin1 }}</span>

    <onboarding-payslip-upload-input id="bulletin2-upload" @uploaded="onFileUploaded('bulletin2', $event)" caption=".2" label="Bulletin de salaire (2)" />
    <span v-if="errors.bulletin2" class="text-red">{{ errors.bulletin2 }}</span>

    <onboarding-payslip-upload-input id="bulletin3-upload" @uploaded="onFileUploaded('bulletin3', $event)" caption=".3" label="Bulletin de salaire (3)" />
    <span v-if="errors.bulletin3" class="text-red">{{ errors.bulletin3 }}</span>

    <p class="text-read text-grey-600 text-center mt-6">
      Format de fichier supporté: PDF, DOC, XLS. Taille max: 5MB.
    </p>
  </form>
</template>

